import React, { useState, forwardRef, useImperativeHandle } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Global } from "@emotion/react";
import ScopedCssBaseline from "@mui/material/ScopedCssBaseline";
import "react-loading-skeleton/dist/skeleton.css";
import { hideIntercom, showIntercom } from "../utils/Utils.js";
import SubmitBtn from "./submitButton.jsx";
import { colors, zIndexes } from "./common/mixins.js";

const PleaseLoginPrompt = forwardRef(({ prompt, desc, icon, btnText, loginClickCallBack, mandatory, onClose }, ref) => {
  useImperativeHandle(ref, () => ({
      handleOpen,
      handleClose
  }));

  const handleUserClose = () => {
    if (mandatory) return;
    handleClose();
  };

  if (!btnText) btnText = tickets_resources.SignIn

  const [open, setOpen] = useState(false);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const navTabs = document.querySelector(".tabsContainer");

  if (open) {
    hideIntercom();
    if (navTabs) {
      navTabs.style.marginRight = "10px";
    }
    if (!document.getElementById("homepage"))
      document.documentElement.style.overflow = "hidden";
    document.querySelector("body").style.marginRight = `10px`;
  } else {
    showIntercom();
    if (!document.getElementById("homepage"))
      document.documentElement.style.overflow = "unset";
    document.querySelector("body").style.marginRight = `0px`;
    if (navTabs) {
      navTabs.style.marginRight = "0";
    }
  }

  const StyledBox = styled(Box)(({ theme }) => ({
    backgroundColor: "#fff",
  }));

  const Puller = styled(Box)(({ theme }) => ({
    width: 48,
    height: 4,
    backgroundColor: colors.pullerColor,
    borderRadius: 3,
    position: "absolute",
    top: 16,
    left: "calc(50% - 24px)",
  }));

  const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
    padding: "24px !important",
  }));

  const destroyModal = () => {
    $("#modal").remove();
  };

const handleOpen = () => {
    if (navTabs) {
      navTabs.style.marginRight = "10px";
    }
    setOpen(true);
    hideIntercom();
    if (!document.getElementById("homepage"))
      document.documentElement.style.overflow = "hidden";
    document.querySelector("body").style.marginRight = `10px`;
  };

  const handleClose = () => {
    if (navTabs) {
      navTabs.style.marginRight = "0";
    }
    showIntercom();
    if (!document.getElementById("homepage"))
        document.documentElement.style.overflow = "unset";
        document.querySelector("body").style.marginRight = `0px`;
        destroyModal();
        setOpen(false);
        if (onClose) onClose();
    };

    return (
    <ScopedCssBaseline sx={{ display: "contents" }}>
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            maxHeight: `calc(100% - 32px)`,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            scrollbarColor: "#CFD1D1 transparent",
            "*::-webkit-scrollbar": {
              width: "7px",
            },
            "*::-webkit-scrollbar-track": {},
            "*::-webkit-scrollbar-thumb": {
              backgroundColor: "#CFD1D1",
              borderRadius: "5px ",
            },
          },
          ".MuiDialog-paper": {
            scrollbarColor: "#CFD1D1 transparent",
            "*::-webkit-scrollbar": {
              width: "7px",
            },
            "*::-webkit-scrollbar-track": {},
            "*::-webkit-scrollbar-thumb": {
              backgroundColor: "#CFD1D1",
              borderRadius: "5px ",
            },
          },
          ".MuiDialogTitle-root": {
            padding: "24px !important",
          },
        }}
      />
      {fullScreen ? (
        mandatory ? (
        <Drawer
          anchor="bottom"
          open={open}
          onClose={handleUserClose}
          disableScrollLock={false}
          sx={{ zIndex: zIndexes.fixedBottomBar + 1 }}
        >

          <StyledBox
            sx={{
              borderTopLeftRadius: 16,
              borderTopRightRadius: 16,
              right: 0,
              left: 0,
              pt: 2,
            }}
          >
            {!mandatory && <Puller />}
          </StyledBox>
          <StyledBox
            sx={{
              px: 2,
              pb: 2,
              overflow: "auto",
              marginTop: "48px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 24,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <img src={icon} style={{ width: 124, height: 124 }} />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                  }}
                >
                  <span
                    style={{
                      fontSize: 20,
                      fontFamily: "pf_highway_sans_pro_mediumRg",
                      textAlign: "center",
                      fontHeight: "100%"
                    }}
                  >
                    {prompt}
                  </span>
                  {desc && (
                    <span style={{ fontSize: 16, textAlign: "center" }}>
                      {desc}
                    </span>
                  )}
                </div>
              </div>
              <div style={{ display: "flex", width: "60%" }}>
                <SubmitBtn
                  toDoOnClick={loginClickCallBack ? loginClickCallBack : () => LoginClick(window.location.href)}
                  buttonText={btnText}
                  isBottom
                />
              </div>
            </div>
          </StyledBox>
        </Drawer>
        ) : (
        <SwipeableDrawer
          anchor="bottom"
          open={open}
          onOpen={handleOpen}
          onClose={handleUserClose}
          disableSwipeToOpen={false}
          disableScrollLock={false}
          sx={{ zIndex: zIndexes.fixedBottomBar + 1 }}
        >
          <StyledBox
            sx={{
              borderTopLeftRadius: 16,
              borderTopRightRadius: 16,
              right: 0,
              left: 0,
              pt: 2,
            }}
          >
            {!mandatory && <Puller />}
          </StyledBox>
          <StyledBox
            sx={{
              px: 2,
              pb: 2,
              overflow: "auto",
              marginTop: "48px",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 24 }}>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
                <img src={icon} style={{ width: 124, height: 124 }} />
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                  <span style={{ fontSize: 20, fontFamily: "pf_highway_sans_pro_mediumRg", textAlign: "center", fontHeight: "100%" }}>
                    {prompt}
                  </span>
                  {desc && <span style={{ fontSize: 16, textAlign: "center" }}>{desc}</span>}
                </div>
              </div>
              <div style={{ display: "flex", width: "60%" }}>
                <SubmitBtn
                  toDoOnClick={loginClickCallBack ? loginClickCallBack : () => LoginClick(window.location.href)}
                  buttonText={btnText}
                  isBottom
                />
              </div>
            </div>
          </StyledBox>
        </SwipeableDrawer>
        )
      ) : (
        <Dialog
          open={open}
          onClose={handleUserClose}
          disableEscapeKeyDown={mandatory}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            sx: {
              bgcolor: "white",
              maxWidth: "revert",
              borderRadius: "8px",
              width: 560,
            },
          }}
        >
          {!mandatory && (
            <DialogTitle
              className="r_dialogTitle"
              style={{
                position: "absolute",
                justifyContent: "flex-end",
              }}
            >
              <CloseIcon onClick={handleClose} className="r_dialogTitleIcon" />
            </DialogTitle>
          )}
          <StyledDialogContent>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 24,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <img src={icon} style={{ width: 124, height: 124 }} />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                  }}
                >
                  <span
                    style={{
                      fontSize: 20,
                      fontFamily: "pf_highway_sans_pro_mediumRg",
                      textAlign: "center",
                      fontHeight: "100%"
                    }}
                  >
                    {prompt}
                  </span>
                  {desc && (
                    <span style={{ fontSize: 16, textAlign: "center" }}>
                      {desc}
                    </span>
                  )}
                </div>
              </div>
              <div style={{ display: "flex", width: "60%" }}>
                <SubmitBtn
                  toDoOnClick={loginClickCallBack ? loginClickCallBack : () => LoginClick(window.location.href)}
                  buttonText={btnText}
                  isBottom
                />
              </div>
            </div>
          </StyledDialogContent>
        </Dialog>
      )}
    </ScopedCssBaseline>
  );
});

export default PleaseLoginPrompt;
